import { useCallback, useContext, useEffect, useState } from 'react';
import { useEditContext } from 'react-admin';

import { AppContext } from '@app/contexts';
import { conditionalFields, formFields, isArrayEqual, transformRails } from '@app/utils/railsUtils';
import { validateConditionalFields, validateFormFields } from '@app/utils/validateUtils';
import update from 'immutability-helper';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';
import EditView from '@app/components/common/views/EditView';

import { RailForm } from './RailForm';

export const EditRails = () => {
  const [selected, setSelected] = useState<GenericObject[]>([]);
  const [value, setValue] = useState<string>('');
  const [firstRenderSelected, setFirstRenderSelected] = useState<GenericObject[]>([]);
  const validate = useCallback((values: GenericObject) => {
    setValue(values.page_type as string);
    const errors = validateFormFields({ fields: formFields, values });
    const conditionalFieldsErrors = validateConditionalFields({ fields: conditionalFields, values });
    return { ...errors, ...conditionalFieldsErrors };
  }, []);

  const handleChangeSelected = (values: GenericObject[]) => {
    setSelected(values);
  };

  const handleChangeFirstRenderSelected = (values: GenericObject[]) => {
    setFirstRenderSelected(values);
  };

  const { handleChangeLoading } = useContext(AppContext);
  const { saving } = useEditContext();

  useEffect(() => {
    handleChangeLoading(!!saving);
  }, [saving, handleChangeLoading]);

  const moveCard = useCallback((dragIndex: number, hoverIndex: number) => {
    setSelected((prevCards) =>
      update(prevCards, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, prevCards[dragIndex]],
        ],
      })
    );
  }, []);

  const transform = (values: GenericObject) => {
    return transformRails(selected, values);
  };

  const customDiscardValidation = () => {
    return isArrayEqual(firstRenderSelected, selected);
  };

  return (
    <div>
      <EditView
        resourceSingular="rail"
        customDiscardValidation={customDiscardValidation}
        validate={validate}
        transform={transform}
        redirect={`/rails?type=${value}`}
        mutationMode="pessimistic">
        <RailForm
          moveCard={moveCard}
          title="EDIT RAIL"
          selected={selected}
          handleChangeFirstRenderSelected={handleChangeFirstRenderSelected}
          editing
          handleChangeSelected={handleChangeSelected}
        />
      </EditView>
    </div>
  );
};
